import React from 'react';

// Components
import MuiKpiPaper from '../../../../components/muikpipaper';
// Models
import type { KpiGrid } from '../../../../models/operationsmodels/KpiModels';

interface B2BProps {
  /** Pre-fetched data for print view — skips Redux read when provided */
  data?: KpiGrid[];
  /** When true, renders all grids flat without tabs or interactive controls */
  isPrintView?: boolean;
}

/**
 * B2B Component - Wrapper for B2B KPI display
 */
const B2B: React.FC<B2BProps> = ({ data, isPrintView }) => {
  return <MuiKpiPaper cardTitle="B2B" data={data} isPrintView={isPrintView} />;
};

export default B2B;
